<template>
  <Orders />
</template>
<script>
import appConfig from '@/app.config'
import Orders from '../../../components/mooc/orders/Orders.vue'
export default {
  page: {
    title: 'جزئیات مدیریت سفارشات',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-detail-orders',
  components: { Orders },
}
</script>
